export enum ActionConstants {
	SET_PROFITS = 'set_profits',
}
